import DlpPolicyMatchDetail from 'owa-service/lib/contract/DlpPolicyMatchDetail';
import DlpPolicyTipAction from 'owa-service/lib/contract/DlpPolicyTipAction';
import PolicyMatchWrapper from '../store/schema/PolicyMatchWrapper';

export function getHighestPriorityPolicyTipMatchDetail(
    policyMatchWrapper: PolicyMatchWrapper
): DlpPolicyMatchDetail {
    const policyMatchDetails = policyMatchWrapper.policyMatchDetails;
    const unifiedDLPRules = policyMatchDetails.filter(detail => detail.MatchPriority != 0);
    return unifiedDLPRules.length > 0
        ? // Sort ascending by MatchPriority
          unifiedDLPRules.sort(
              (detailA, detailB) => detailB.MatchPriority - detailA.MatchPriority
          )[0]
        : // Sort descending by default action priority
          policyMatchDetails
              .slice()
              .sort(
                  (detailA, detailB) =>
                      getDefaultActionPriority(detailA.Action) -
                      getDefaultActionPriority(detailB.Action)
              )[0];
}

function getDefaultActionPriority(action: DlpPolicyTipAction): number {
    switch (action) {
        case DlpPolicyTipAction.NotifyOnly:
            return 0;
        case DlpPolicyTipAction.RejectUnlessFalsePositiveOverride:
        case DlpPolicyTipAction.RejectUnlessSilentOverride:
        case DlpPolicyTipAction.RejectUnlessExplicitOverride:
            return 1;
        case DlpPolicyTipAction.RejectMessage:
            return 2;
        default:
            return 3;
    }
}
